import React from 'react';
import { Link } from 'react-router-dom';
import clsx from 'clsx';
import { withStyles } from '@material-ui/core';
import styles from './style';
import useDesktop from '../../hooks/useDesktop';
import CheckCircleRounded from '../../assets/icons/CheckCircleRounded';
import Button from '../atomic/Button';
import PrintIcon from '../../assets/icons/PrintIcon';

const OrderConfirmation = ({ classes }) => {
  const isDesktop = useDesktop();

  return (
    <div
      className={clsx([
        classes.insuranceContent,
        classes.confirmationContent,
        !isDesktop && 'mobile',
      ])}
    >
      <div className={classes.thankyouBlock}>
        <div className={classes.row}>
          <CheckCircleRounded className={classes.confirmationChecked} />
          <h2>Du er forsikret!</h2>
        </div>
        <p>
          Takk for ditt kjøp av Trygt utført - Boligmappas advokatforsikring for
          håndverkertjenester.
        </p>
        <p>
          Du finner ditt forsikringsbevis og forsikringsvilkår i personlig
          område her i Boligmappa.
        </p>
        <Link
          to="/properties"
          className={clsx([classes.backButton])}
          color="primary"
          variant="contained"
          type="button"
        >
          Tilbake til Boligmappa
        </Link>
      </div>
      <div className={classes.summary}>
        <h2>Sammendrag</h2>
        <p className={classes.summaryText}>
          En kopi av sammendraget er sendt til nina.torset@gmail.com.
        </p>
        <div className={classes.summaryBlocks}>
          <div className={classes.summaryInfo}>
            <p className={classes.summaryLabel}>Ordredetaljer</p>
            <div className="row">
              <p>Forsikring Trygt Utført</p>
              <p>990 kr / stk</p>
            </div>
            <div className="row">
              <p>MVA</p>
              <p>0 kr</p>
            </div>
            <div className="row">
              <p>
                <b>Total sum (inkl MVA)</b>
              </p>
              <p>
                <b>990 kr</b>
              </p>
            </div>
          </div>
          <div className={classes.summaryInfo}>
            <p className={classes.summaryLabel}>Bestillingsinformasjon</p>
            <div className="row">
              <p>Kundenummer</p>
              <p>102034</p>
            </div>
            <div className="row">
              <p>Dato for kjøp</p>
              <p>01.01.2024</p>
            </div>
            <div className="row">
              <p>Betalingstype</p>
              <p>Vipps</p>
            </div>
          </div>
          <div className={classes.summaryInfo}>
            <p className={classes.summaryLabel}>Personopplysninger</p>
            <div className="row">
              <p>Navn</p>
              <p>Nina Torset</p>
            </div>
            <div className="row">
              <p>Adresse</p>
              <p>Boligveien 32, 0176 Oslo</p>
            </div>
            <div className="row">
              <p>Epost</p>
              <p>nina.torset@gmail.com</p>
            </div>
            <div className="row">
              <p>Telefon</p>
              <p>986 11 270</p>
            </div>
          </div>
        </div>
        <div className={classes.buttonsRow}>
          <Button
            className={classes.summaryButton}
            type="button"
            onClick={() => window.print()}
          >
            <PrintIcon className={classes.buttonIcon} />
            Skriv ut
          </Button>
        </div>
      </div>
      <h2>Har du behov for å melde skade?</h2>
      <p className={classes.damageReport}>
        Forsikringen er gyldig fra kjøpstidspunktet. Vi gjør oppmerksom på at
        det kan ta 2-5 dager før kundeforholdet blir oppdatert i Help sine
        systemer.
        <br />
        <br />
        Dersom du har behov for å melde skade allerede nå, ber vi deg{' '}
        <Link to="#" className={classes.textLink}>
          lese denne hjelpeartikkelen.
        </Link>
      </p>
    </div>
  );
};

export default withStyles(styles)(OrderConfirmation);
